import React , {  useState } from 'react';


import InputAdornment from '@material-ui/core/InputAdornment';
import { getRandomNumber } from '../../utils/Utils';
import TextField from '@material-ui/core/TextField';
import { CustomIcon } from 'ams-ui-reactkit';

const TextFieldRenderer = (props: any) => {

    const [value, setValue] = useState(props?.defaultValue);
    const { label, onChange, id, startAdorment,endAdornment, endAdornmentClick, name, onBlur, ...rest } = props;

    const renderInputAdornment = (type:string) => {

        if (startAdorment && type=="start") {
            return (
                <InputAdornment position="start">{startAdorment}</InputAdornment>
            );
        }
        if (endAdornment && type=="end") {
            return (
                <InputAdornment position="end" className='color-grey endAdornment'>
                    <span onClick={endAdornmentClick}>
                        <CustomIcon iconName={endAdornment} size="small" />
                    </span>
                </InputAdornment>
            );
        }

        return undefined;
    }

    const onChangeHandler = (e: any) => {
        setValue(e.target.value);
        onChange && onChange(e.target.value, e);
    }
    const onBlurHandler = (e: any) => {
        onBlur && onBlur(e.target.value, e);
    }

    return (
        <>

            <TextField
                label={label}
                id={id+""}
                defaultValue={value}
                onChange={onChangeHandler}
                onBlur={onBlurHandler}
                InputProps={{
                    startAdornment: renderInputAdornment("start"),
                    endAdornment:renderInputAdornment("end")
                }}
                {...rest}
            />

        </>
    );

}

TextFieldRenderer.defaultProps = {
    id: getRandomNumber(),
    endAdornment: "",
    endAdornmentClick:()=>{}
}

export default TextFieldRenderer;